// Shared ordered list of application languages exposed in the language selector.
export type Localization = (typeof localizations)[number]
export type Locale = Localization['code']

export const localizations = [
  {
    code: 'ru',
    short: 'Rus',
    title: 'Русский',
    timeFormat: '24',
    currency: 'rub',
    isDefault: true,
    isEnabled: true,
  },
  {
    code: 'en',
    short: 'Eng',
    title: 'English',
    timeFormat: 'ampm',
    currency: 'usd',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'kz',
    short: 'Kaz',
    title: 'Қазақша',
    timeFormat: '24',
    currency: 'kzt',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'ka',
    short: 'Geo',
    title: 'ქართული',
    timeFormat: '24',
    currency: 'gel',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'hy',
    short: 'Arm',
    title: 'Հայերեն',
    timeFormat: '24',
    currency: 'amd',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'ky',
    short: 'Kyr',
    title: 'Кыргызча',
    timeFormat: '24',
    currency: 'kgs',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'hi',
    short: 'Hin',
    title: 'हिन्दी',
    timeFormat: '24',
    currency: 'inr',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'th',
    short: 'Tha',
    title: 'ไทย',
    timeFormat: '24',
    currency: 'thb',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'vi',
    short: 'Vie',
    title: 'Tiếng Việt',
    timeFormat: '24',
    currency: 'vnd',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'fil',
    short: 'Fil',
    title: 'Filipino',
    timeFormat: '24',
    currency: 'php',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'lo',
    short: 'Lao',
    title: 'ລາວ',
    timeFormat: '24',
    currency: 'lak',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'km',
    short: 'Khm',
    title: 'ភាសាខ្មែរ',
    timeFormat: '24',
    currency: 'khr',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'mn',
    short: 'Mon',
    title: 'Монгол',
    timeFormat: '24',
    currency: 'mnt',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'ko',
    short: 'Kor',
    title: '한국어',
    timeFormat: '24',
    currency: 'krw',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'ja',
    short: 'Jpn',
    title: '日本語',
    timeFormat: '24',
    currency: 'jpy',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'pt-br',
    short: 'Por',
    title: 'Português do Brasil',
    timeFormat: '24',
    currency: 'brl',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'id',
    short: 'Ind',
    title: 'Bahasa Indonesia',
    timeFormat: '24',
    currency: 'idr',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'es',
    short: 'Spa',
    title: 'Español',
    timeFormat: '24',
    currency: 'eur',
    isDefault: false,
    isEnabled: true,
  },
  {
    code: 'es-ar',
    short: 'Arg',
    title: 'Español (Argentina)',
    timeFormat: '24',
    currency: 'ars',
    isDefault: false,
    isEnabled: true,
  },
] as const

export const defaultLocale = localizations[0].code
